// Service
import OtpService from '../../services/otp.service';
// Reducer
import * as OtpReducer from './otp.reducers';
  
  // Generate OTP Code ====================================================================================================

  export const generateTheOtpCode = (data) => async (dispatch) => {
    dispatch(OtpReducer.setGenerateOtpLoading());

    try {

      const response = await OtpService.generateTheOtpCode(data);

      dispatch(OtpReducer.setGenerateOtpScuccess(response.data));

    } catch(error) {

      dispatch(OtpReducer.setGenerateOtpFailure(error.response?.data?.message?.message || error.message));
    }

  }


    
  // Validate OTP Code ====================================================================================================

  export const validateTheOtpCode = (data) => async (dispatch) => {
    dispatch(OtpReducer.setValidateOtpLoading());

    try {

      const response = await OtpService.validateTheOtpCode(data);

      dispatch(OtpReducer.setValidateOtpScuccess(response.data));

    } catch(error) {

      dispatch(OtpReducer.setValidateOtpFailure(error.response?.data?.message?.message || error.message));
    }

  }

      
  // Clean up OTP State ====================================================================================================

  export const cleanUpOtpState = () => async (dispatch) => {
    dispatch(OtpReducer.resetOtpState());
  }